module.exports = __webpack_public_path__ + "media/images/city/064-cn-tower-3fdbb26b90840918397ffea277e89512.svg";